import { FC } from "react";
import { formatDateCustom } from "@app/shared/formatDateTime";

interface ArchivedDatePillProps {
  dateArchived: string | null;
  /** Required so every rendered pill is uniquely targetable in tests (consumers pass a per-project id). */
  testId: string;
}

// Grey pill shown on archived project cards/rows, e.g. "Archived Mar 12, 2026". Renders nothing when the
// archive date is unavailable so the layout degrades gracefully rather than showing an empty pill.
export const ArchivedDatePill: FC<ArchivedDatePillProps> = ({ dateArchived, testId }) => {
  if (!dateArchived) return null;

  return (
    <span className="network-portfolio-management-archived-pill" data-testid={testId}>
      Archived {formatDateCustom(dateArchived, "MMM D, YYYY")}
    </span>
  );
};
